import { useOrganisationQuery } from 'src/graphql/_generated';
import { useAuth } from 'src/state/auth';
import { normalizeHexColor } from 'src/utils/color';

type OrganisationBranding = {
  logoUrl?: string;
  logoDataUrl?: string;
  primaryColor?: string | null;
  secondaryColor?: string | null;
};

export const useOrganisationBranding = (): OrganisationBranding => {
  const { profile } = useAuth();
  const organisationId = profile?.activeOrganisation?.id;

  const { data } = useOrganisationQuery({
    variables: { id: organisationId },
    skip: !organisationId,
  });

  const organisation = data?.organisation;
  const logoDataUrl = organisation?.logoDataUrl ?? profile?.activeOrganisation?.logoDataUrl ?? undefined;
  const logoUrl = logoDataUrl ?? organisation?.logoUrl ?? profile?.activeOrganisation?.logoUrl ?? undefined;
  const primaryColor =
    normalizeHexColor(organisation?.primaryColor ?? profile?.activeOrganisation?.primaryColor ?? undefined) ?? null;
  const secondaryColor =
    normalizeHexColor(organisation?.secondaryColor ?? profile?.activeOrganisation?.secondaryColor ?? undefined) ?? null;

  return {
    logoUrl,
    logoDataUrl,
    primaryColor,
    secondaryColor,
  };
};
